import React from "react";
import { TableCell, TableRow, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { POSITIVE_COLOR, VALUE_FONT_WEIGHT } from "../../Constants";
import { useSelector } from "react-redux";
import { selectWalletById } from "../../store/walletSlice";
import WalletIcon from "../layout/WalletIcon";
import { selectCurrencies } from "../../store/currencySlice";
import { selectCategory } from "../../store/categorySlice";
import {useTranslation} from "react-i18next";

const TransactionIncome = ({ transaction, onClick }) => {
    const {t} = useTranslation();
    const description = transaction.description || t("common.transactionType.income");
    const value = transaction.valueTo;
    const wallet = useSelector((state) => selectWalletById(state, transaction.walletTo));
    const currencies = useSelector(selectCurrencies) || [];
    const currency = wallet?.currency != null
        ? currencies.find((c) => c.id === wallet.currency || c.id == wallet.currency)
        : null;
    const displayValue = currency?.shortName ? `${value} ${currency.shortName}` : value;
    const category = useSelector(selectCategory(transaction.categoryFrom));
    const categoryLabel = category?.name || (transaction.categoryFrom != null ? String(transaction.categoryFrom) : "");

    const isDraft = transaction?.state === "DRAFT";

    return (
        <TableRow
            key={transaction.id}
            className={isDraft ? "Draft" : undefined}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            onClick={(event) => onClick(transaction)}
        >
            <TableCell padding="none" align="center" sx={{ width: 56 }}>
                {wallet && <WalletIcon image={wallet.image} sx={{ fontSize: 28 }} />}
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {categoryLabel}
                </Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="body1" sx={{ color: POSITIVE_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                    +{displayValue}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

TransactionIncome.propTypes = {
    transaction: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        description: PropTypes.string,
        valueTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        walletTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default TransactionIncome;
